import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@babel/polyfill'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

// ----- Vuetify ------

import Vuetify from 'vuetify'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'vuetify/dist/vuetify.min.css'

// Styles
import './assets/stylesheet/customer.sass'

// ------ Sentry -------
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://47c53e526d6c4718b3cd594acbfa2fe5@sentry.io/1861038',
    environment: process.env.VUE_APP_API_BASE_URL,
    integrations: [new Integrations.Vue({ Vue, attachProps: true })]
  })
}

Vue.component('clip-loader', ClipLoader)

Vue.use(Vuetify)
Vue.config.productionTip = false

Vue.prototype.$isEmpty = (v) => {
  return (Object.entries(v).length === 0 && v.constructor === Object)
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
